import { z } from "zod";

// TODO: Copied (partially)from firebase/lmt/src/common/types. Replace the file there with imports from this file and move tests if any.

export const NotificationDeliveryMethod = z.enum(["push-notification", "email"]);
export type NotificationDeliveryMethod = z.infer<typeof NotificationDeliveryMethod>;
